module.exports = __webpack_public_path__ + "media/images/brand/lander/left-iceberg-f346a3cf48fae154aea0d1a74382aa85.png";